import {styled} from '@mui/system';
import {CardContent} from '@mui/material';

export const MuiTechnicianSettingsCardContent = styled(CardContent)(() => ({
	paddingTop: 0,
}));
